import React from 'react';
import { createRoot } from 'react-dom/client';

import { SchoolMeetings } from '../main-app/components/SchoolMeetings';

document.addEventListener('DOMContentLoaded', () => {
  const meeting = document.getElementById('react-school-booking-meetings');

  if (meeting) {
    const root = createRoot(meeting);
    root.render(
      <SchoolMeetings
        isMessageAllowed={meeting.getAttribute('data-school-message-allowed') === 'true'}
        schoolId={meeting.getAttribute('data-school-key')}
        schoolName={meeting.getAttribute('data-school-name')}
        schoolTimeZone={meeting.getAttribute('data-school-timezone-name')}
        schoolPhone={meeting.getAttribute('data-school-phone')}
        schoolBookableMeetingKinds={meeting
          .getAttribute('data-school-bookable-meeting-kinds')
          .split(',')}
      />,
    );
  }
});
